import { AutocompleteDirective } from '@shared/directives/autocomplete.directive';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DatepickerService } from '@shared/services/datepicker.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { WINDOW } from '../../../app.module';
import { Component, effect, HostListener, Inject, inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
 selector: 'iho-autocomplete',
 templateUrl: './auto-complete.component.html',
 styleUrls: ['./auto-complete.component.scss'],
 standalone: true,
 imports: [AutocompleteDirective, CommonModule, MatFormFieldModule, MatInputModule, MatTabsModule],
})
export class AutoCompleteComponent {
 autocompleteService = inject(AutocompleteService);
 datepickerService = inject(DatepickerService);
 searchBoxService = inject(SearchBoxService);
 router = inject(Router);

 constructor(
  @Inject(PLATFORM_ID) private platformId: Record<string, string>,
  @Inject(WINDOW) private window: Window
 ) {
  if (isPlatformBrowser(this.platformId) && localStorage.getItem('RecentSearches')!) {
   this.autocompleteService.setRecent(
    JSON.parse(localStorage.getItem('RecentSearches')!).filter(
     (item: any) =>
      item.ecolodge ==
       (this.searchBoxService.accommodation() == 'ecolodge' ? 'ecolodge' : 'hotel') &&
      item?.isShabAdsCode == false
    )
   );
  }

  this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
   if (event instanceof NavigationEnd) {
    this.autocompleteService.setRecent(
     JSON.parse(localStorage.getItem('RecentSearches')!).filter(
      (item: any) =>
       item.ecolodge ==
        (this.searchBoxService.accommodation() == 'ecolodge' ? 'ecolodge' : 'hotel') &&
       item?.isShabAdsCode == false
     )
    );
   }
  });
 }

 setSelectedItem(item: any) {
  this.autocompleteService.setSelectedItem(item);
  this.autocompleteService.setState('hide');
  if (this.datepickerService._startDate() === '' || this.datepickerService._endDate() === '') {
   setTimeout(() => {
    this.datepickerService.setState(true);
   });
  }
 }

 setRecentItem(item: any) {
  this.autocompleteService.adCode.set(true);

  const minDate = new Date(this.datepickerService._minDate());
  const searchStartDate = new Date(item.date);
  const searchEndDate = new Date(item.endDate);
  if (searchStartDate < minDate && searchEndDate > minDate) {
   item.date = this.datepickerService._minDate();
  } else if (searchEndDate < minDate) {
   item.date = null;
   item.endDate = this.datepickerService._endDate();
  }
  this.autocompleteService.setSelectedItem(item);
  this.autocompleteService.setState('hide');
  if (this.datepickerService._startDate() === '' || this.datepickerService._endDate() === '') {
   this.datepickerService.setState(true);
  }
  this.datepickerService.setStartDate(item.date);
  this.datepickerService.setEndDate(item.endDate);
 }
  searchNothing(){
    this.searchBoxService.noSearchResult.set(true);
    let parameters = {
      id: 0,
      type: 6,
      link: '',
      name: this.autocompleteService._result(),
      state: '',
      isShabAdsCode: this.autocompleteService._selectedItem().isShabAdsCode,
      startDate: this.datepickerService._startDate(),
      endDate: this.datepickerService._endDate(),
    };
  
    this.searchBoxService.triggerSearch(parameters, false, this.autocompleteService.adCode());
    this.autocompleteService.setState('hide')
    
    
  }
 @HostListener('document:click', ['$event']) clickout(event: any) {
  if (this.datepickerService._isMobile() === false) {
   if (!event.target.closest('.iho-autocomplete')) {
    this.autocompleteService.setState('hide');
   }
  }
 }
  shouldShow(item: any): boolean {
    const { type } = item;
    return type === 1 || type === 2 || type === 3 || type === 5 || type === 6;
  }

}
